import { cn } from '@helpers/cn';

/**
 * A small red dot that points at something the user has not looked at yet.
 * Screen readers hear `label` instead of the dot. Leave it out where the text
 * next to the dot already says the same.
 */
function AttentionDot({
  label,
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'eye:inline-block eye:size-8 eye:shrink-0 eye:rounded-full eye:bg-red-100',
        className,
      )}
    >
      {label ? <span className='eye:sr-only'>{label}</span> : null}
    </span>
  );
}

export default AttentionDot;
